import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useImperativeHandle } from "react";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import { sortArrays } from "../../utils/functions";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";

const ScrollDataTable = (
  {
    tableData,
    //setMainData,
    tableClass,
    columns,
    EmptyState,
    sortingConfig,
    setSortingConfig,
    setLoader,
  },
  ref,
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAddingData, setisAddingData] = useState(false);

  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);

  const tableRef = useRef();

  const { clmName, isAscending, type, keyLevel, keysObj } = sortingConfig;

  //const parentScroll = useRef(null);

  const headerRenderer = ({
    label,
    key,
    sortable,
    width,
    classn,
    keyConfig,
  }) => (
    <th
      aria-sort={
        clmName === key ? (isAscending ? "Ascending" : "Descending") : undefined
      }
      className={classn && classn}
    >
      {sortable ? (
        <div className="header_cell">
          <button
            className="scrollTableHeader blueTextColor header-button"
            onClick={() => {
              const config = {
                ...keyConfig,
                isAscending: clmName === key ? !isAscending : false,
              };
              setSortingConfig({ ...config });
            }}
          >
            <p>{label}</p>
            <div className="accordion_table_header_child_icon">
              <img
                aria-hiddden={true}
                src={
                  isAscending && clmName === key
                    ? sortedIcon
                    : !isAscending && clmName === key
                      ? sortedAtoz
                      : clmName !== key
                        ? unsortedIcon
                        : unsortedIcon
                }
                alt="sort"
              />
            </div>
          </button>
        </div>
      ) : (
        <div className="header_cell">
          <div className="scrollTableHeader blueTextColor">
            <p>{label}</p>
          </div>
        </div>
      )}
    </th>
  );

  const handleScrollStart = (e, text) => {
    //const scrollTop = parentScroll.current.scrollTop;
    // if (scrollTop >= 1) {
    //   searchInputRef?.current?.blur();
    // }

    if (
      e.target.clientHeight + e.target.scrollTop + 2 > e.target.scrollHeight &&
      mainData?.length
    ) {
      if (data) {
        setisAddingData(true);
        setData((prev) => {
          if (prev) {
            return [
              ...prev,
              ...mainData?.slice(prev?.length, prev?.length + 100),
            ];
          }
        });
        setTimeout(() => {
          setisAddingData(false);
        }, 200);
      }
    }
  };

  useImperativeHandle(ref, () => {
    return {
      handleScrollStart,
      scroll: () => {
        tableRef.current.scrollIntoView({ behavior: "smooth" });
      },
    };
  });

  useEffect(() => {
    if (mainData.length) {
      setData(mainData?.slice(0, 100));
    }
  }, [mainData]);

  useEffect(() => {
    if (tableData.length) {
      const defaultConfig = {
        rowData: tableData,
        reqSortOrder: isAscending,
        keyLevel,
        keysObj,
        type,
      };
      const data = sortArrays({ ...defaultConfig });
      if (data.length) {
        setMainData(data);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
    } else setIsLoading(false);
  }, [tableData, clmName, isAscending]);

  return (
    <>
      {!isLoading ? (
        <>
          <table className={` ${tableClass ? tableClass : "custom_table"}`}>
            <thead>
              <tr>{data?.length ? columns?.map(headerRenderer) : <></>}</tr>
            </thead>

            {data.length ? (
              <tbody>
                {data.map((eachRow, index) => {
                  return (
                    <tr>
                      {columns.map((column, idx) => {
                        return (
                          <td>
                            {column.cellRenderer
                              ? column.cellRenderer(
                                  eachRow[column.key],
                                  eachRow,
                                  column.key,
                                  index,
                                )
                              : eachRow[column.key]}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <EmptyState />
            )}
          </table>
          {isAddingData
            ? ""
            : // <div style={{ position: "absolute", left: "50%" }}>
              //   <div style={{ position: "relative", width: "200px" }}>
              //     {/* <div id="preloader">
              //       <div id="loader"></div>
              //     </div> */}
              //   </div>
              // </div>
              ""}
        </>
      ) : (
        <div className="loader_instrument_details">
          <div className="loader_wrapper">
            <img className="loader_gif" src={loaderGIF} alt="loading..." />
          </div>
        </div>
      )}
    </>
  );
};

export default forwardRef(ScrollDataTable);
